import { X } from "lucide-react";

const TONE_STYLES = {
  coral: {
    title: "text-[#FF5E47]",
    closeButton:
      "border-[#ffd9d2] text-[#FF5E47] hover:border-[#FF5E47] hover:bg-[#fff4f1]",
    cancelButton:
      "border-[#FF5E47] bg-white text-[#FF5E47] hover:bg-[#fff4f1]",
    confirmButton: "bg-[#FF5E47] text-white hover:bg-[#e64d37]",
  },
  violet: {
    title: "text-[#0B2B66]",
    closeButton:
      "border-[#d7ddff] text-[#0B2B66] hover:border-[#08059B] hover:bg-[#f5f7ff]",
    cancelButton:
      "border-[#0B2B66] bg-white text-[#0B2B66] hover:bg-[#f5f7ff]",
    confirmButton: "bg-[#0B2B66] text-white hover:bg-[#08059B]",
  },
};

export default function LogoutConfirmDialog({
  open,
  onCancel,
  onConfirm,
  tone = "coral",
}) {
  if (!open) {
    return null;
  }

  const styles = TONE_STYLES[tone] || TONE_STYLES.coral;

  return (
    <div className="fixed inset-0 z-[140] flex items-center justify-center bg-[#111827]/40 px-4 backdrop-blur-sm">
      <div className="relative w-full max-w-md rounded-[32px] border border-[#ddd3c6] bg-white p-6 shadow-[0_24px_70px_rgba(11,43,102,0.18)]">
        <button
          type="button"
          onClick={onCancel}
          className={`absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full border bg-white transition ${styles.closeButton}`}
          aria-label="Close logout popup"
        >
          <X size={18} />
        </button>

        <h2 className={`mt-8 text-center text-3xl font-medium ${styles.title}`}>
          Are you sure you want to logout?
        </h2>
        <p className="mt-3 text-center font-sans text-[16px] font-normal leading-[1.55] text-[#5f6776]">
          You&apos;ll be signed out of your account and can log back in any time.
        </p>

        <div className="mt-6 flex flex-col gap-3 sm:flex-row">
          <button
            type="button"
            onClick={onCancel}
            className={`inline-flex flex-1 items-center justify-center rounded-2xl border px-5 py-3 text-base font-medium transition ${styles.cancelButton}`}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={`inline-flex flex-1 items-center justify-center rounded-2xl px-5 py-3 text-base font-medium transition ${styles.confirmButton}`}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}
